<template>
  <section v-if="computedHits.length">
    <ProductListSection
      :title="`Most Popular for ${gift?.storeName}`"
      class="mx-auto max-w-7xl"
      :try-on-available-frames="tryOnAvailableFrames"
      :products="computedHits"
    />
  </section>
</template>

<script setup lang="ts">
import {
  normalizationFrameHit,
  productAttributesToRetrieve,
} from '@/utils/normalize/algoliaSearchNormalize'
import { ref, computed, watchEffect } from '#imports'
import { useGuestStore } from '~/store/guest'
import { useFittingbox } from '~/composables/useFittingbox'
import { formatSkuId } from '~/utils/skuIdGetters'
import { useEmployeeAlgolia } from '~/composables/useEmployeeAlgolia'
import type { ZnAlgoliaProduct } from '@/types/algolia-results/algolia-types'

const { search, result } = useEmployeeAlgolia<ZnAlgoliaProduct>()
const { gift } = useGuestStore()
const { getAvailableFrames } = useFittingbox()

// TODO: We should reconfigure the filters when we have more data about how to filter the popular products
const maxHits = 4
const popularProductsSearchParams = {
  queryParams: {
    query: '',
    requestOptions: {
      filters: `categories:"frame"`,
      hitsPerPage: maxHits,
      attributesToRetrieve: productAttributesToRetrieve,
    },
  },
  mergeB2C: true,
}

// SSR
await search(popularProductsSearchParams)

const tryOnAvailableFrames = ref<string[]>([])

const computedHits = computed<any[]>(() => {
  if (!result.value) return []

  return result.value?.hits
    .filter((hit) => hit.enabled)
    .map((hit) => normalizationFrameHit(hit as any))
})

const refreshTryOnList = async () => {
  const availableFrames = await getAvailableFrames(
    computedHits.value.map((hit) => {
      return formatSkuId(hit.sku)
    }),
  )
  tryOnAvailableFrames.value = availableFrames
}

watchEffect(async () => {
  if (computedHits.value.length && process.client) {
    await refreshTryOnList()
  }
})
</script>
